/* eslint-disable */
define(function (Viewport) {
    /**
    * @title    - Cta Module
    * @desc     - Overall code for Cta module
    * @param    - none
    * @return   - object with public functions and/or variables
    */
    Login = (function() {

        // declare private global variables for this module
        var loginForm       = document.getElementById('loginform');

        var init = function() {
          if(loginForm !== null) {
            var loginInput      = loginForm.querySelectorAll('input');

            for(i = 0; i < loginInput.length; i++) {
              var container   = loginInput[i].parentNode,
                  label       = container.querySelector('label'),
                  input       = loginInput[i];

              if(label !== null) {
                input.setAttribute('placeholder', label.innerHTML);
                container.removeChild(label);
              }
            }

            var url         = window.location,
                search      = url.search.replace('?', '').split('&'),
                isLogin     = false,
                hasError    = false;

            for(i = 0; i < search.length; i++) {
              var label = search[i].split('=')[0],
                  value = search[i].split('=')[1];

              if(label === 'action' && value === 'login') {
                isLogin = true;
              }

              if(label === 'failed' && value === '1') {
                hasError = true;
              }
            }

            if(isLogin && hasError) {
              var errorMessage  = document.createElement('div'),
                  text          = document.querySelectorAll('[data-error]');

              errorMessage.classList.add('form-group__message');
              errorMessage.classList.add('form-group__message--error');
              errorMessage.classList.add('form-group__message--show');
              
              errorMessage.innerHTML = text[0].getAttribute('data-error');

              loginForm.prepend(errorMessage);
            }
          }
        }

        // return public functions and/or variables to use in other modules
        return {
            init: init,
        };


    }());

    Login.init();

});



// WEBPACK FOOTER //
// ./scripts/legacy/modules/login.js